var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButton330(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 91,
    viewBox: "0 0 330 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_330",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 317,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6991 14.3849C61.5116 16.4186 264.785 14.7547 287.261 13.2757C305.523 12.1664 311.923 13.6454 315.825 32.1331C318.01 42.4861 316.761 66.1503 315.201 73.9151C313.327 82.6043 307.552 90.554 291.163 90.1842C276.335 89.8145 67.9111 89.6296 29.3578 90.9238C3.13527 92.033 2.8231 80.7556 1.41832 74.2849C0.0135413 67.8142 -0.766891 41.5618 1.10615 33.9818C5.94482 15.8639 21.2413 13.6454 31.6991 14.3849Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_330)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6991 14.3849C61.5116 16.4186 264.785 14.7547 287.261 13.2757C305.523 12.1664 311.923 13.6454 315.825 32.1331C318.01 42.4861 316.761 66.1503 315.201 73.9151C313.327 82.6043 307.552 90.554 291.163 90.1842C276.335 89.8145 67.9111 89.6296 29.3578 90.9238C3.13527 92.033 2.8231 80.7556 1.41832 74.2849C0.0135413 67.8142 -0.766891 41.5618 1.10615 33.9818C5.94482 15.8639 21.2413 13.6454 31.6991 14.3849Z",
    fill: "url(#paint0_linear_bow_button_330)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89582 74.494C-1.00144 57.5 -0.50107 40 2.23666 31L17.8501 14.3773C31.6709 14.4027 46.5699 14.3999 62.0074 14.3732L1.89582 74.494Z",
    fill: "url(#paint1_linear_bow_button_330)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3402 91.167C47.9267 91.2044 32.9933 91.2519 19.0429 91.311L96.0649 14.2798C110.869 14.2251 125.803 14.1525 140.432 14.0655L63.3402 91.167Z",
    fill: "url(#paint2_linear_bow_button_330)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.566 91.0589C127.004 91.0657 112.137 91.0795 97.3699 91.1013L174.63 13.8318C190.559 13.708 205.633 13.569 219.195 13.42L141.566 91.0589Z",
    fill: "url(#paint3_linear_bow_button_330)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.653 91.0891C206.162 91.071 191.256 91.0591 175.533 91.0552L253.613 12.9658C267.299 12.743 277.004 12.5111 281.07 12.2835C288.14 11.9181 293.739 11.8259 298.238 12.4947L219.653 91.0891Z",
    fill: "url(#paint4_linear_bow_button_330)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.846 90.0134C295.274 90.9464 290.969 91.4331 285.785 91.3336C282.587 91.2658 270.884 91.204 253.55 91.1558L315.049 29.6493C315.23 30.2986 315.407 30.9706 315.579 31.666C318.142 41.9949 316.796 65.2138 314.99 73.8669L298.846 90.0134Z",
    fill: "url(#paint5_linear_bow_button_330)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117 18.5953C117 15.2816 119.686 12.5953 123 12.5953H311C314.314 12.5953 317 15.2816 317 18.5953V84.5953C317 87.909 314.314 90.5953 311 90.5953H123C119.686 90.5953 117 87.909 117 84.5953V18.5953Z",
    fill: "url(#paint6_linear_bow_button_330)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5212 24.532C11.1722 26.5301 10.8823 30.3447 11.0273 31.6162C11.1722 32.8877 13.6367 33.0694 17.1159 32.3428C20.5951 31.6162 22.9145 29.9814 22.1897 27.2567C21.3199 23.2605 18.1306 23.4421 15.5212 24.532ZM25.089 27.9833C25.8139 21.444 28.8582 21.0807 41.1803 23.0788C55.3871 25.4402 60.6059 25.2586 60.7508 26.5301C61.0408 28.7099 53.2126 28.8915 43.6448 28.8915C34.077 28.8915 24.7991 30.3447 25.089 27.9833Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.071 17.0791C306.768 16.2668 306.996 15.2611 308.78 14.3715C316.597 9.80743 327.906 3.34813 329.19 17.4284C329.491 20.8324 329.528 23.3467 329.034 25.01C331.048 17.5832 315.191 15.8804 307.071 17.0791Z",
    fill: "url(#paint7_linear_bow_button_330)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M308.784 14.3734C316.219 10.0407 326.84 3.96718 328.93 15.5719C325.135 11.9359 316.713 13.5995 310.226 14.8763C308.101 15.1858 307.532 16.1142 307.533 17.0039C307.381 17.0426 307.229 17.0426 307.077 17.0813C306.812 16.3076 307.001 15.3019 308.784 14.3734Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M329.041 25.0101C327.372 31.7021 312.462 21.5287 308.137 18.4728C308.137 18.4728 307.378 17.8925 307.112 17.1189C315.193 15.881 331.241 15.3782 329.041 25.0101Z",
    fill: "url(#paint8_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M307.074 17.0799C309.198 16.7705 311.323 16.5771 313.447 16.4997C315.572 16.4223 317.735 16.461 319.821 16.6931C320.883 16.8091 321.946 17.0026 322.97 17.2347C323.994 17.5054 325.019 17.8536 325.967 18.3564C326.916 18.8593 327.788 19.5169 328.357 20.4453C328.964 21.335 329.23 22.4181 329.154 23.5012C329.116 24.0427 329.04 24.5843 328.926 25.0871C328.775 25.59 328.509 26.0929 328.13 26.441C327.75 26.7891 327.219 26.9826 326.726 27.0986C326.195 27.176 325.664 27.176 325.133 27.1373C324.07 27.0212 323.046 26.7118 322.06 26.3636C321.073 26.0155 320.087 25.59 319.1 25.1258C317.165 24.1974 315.306 23.1143 313.485 21.9926C311.664 20.8708 309.881 19.6716 308.098 18.4725C311.588 20.9481 315.193 23.3077 319.062 25.2032C320.011 25.6674 320.997 26.0929 322.022 26.4797C323.046 26.8278 324.07 27.1373 325.133 27.2533C325.664 27.3307 326.195 27.3307 326.726 27.2147C327.257 27.1373 327.788 26.9052 328.206 26.5571C328.623 26.1702 328.889 25.6674 329.04 25.1645C329.192 24.623 329.268 24.0814 329.268 23.5398C329.306 22.4567 329.04 21.335 328.433 20.4066C327.826 19.4782 326.954 18.8206 326.005 18.3178C325.057 17.8149 324.032 17.4668 323.008 17.196C321.984 16.9252 320.921 16.7705 319.859 16.6544C315.61 16.1902 311.285 16.461 307.074 17.0799Z",
    fill: "#FF7E5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M306.428 18.5492C306.315 17.7369 306.657 16.7698 308.554 16.4992C314.928 15.1843 330.408 14.3341 326.495 25.861C325.013 30.232 322.963 32.3981 320.876 32.7461C324.975 30.6962 312.308 20.5996 306.428 18.5492Z",
    fill: "url(#paint9_linear_bow_button_330)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M326.351 26.2092C324.908 19.6332 312.843 17.8542 306.962 17.777C306.773 17.777 306.621 17.777 306.469 17.777C306.659 17.1968 307.227 16.6939 308.517 16.5004C314.891 15.185 330.369 14.3335 326.465 25.861C326.427 26.0158 326.389 26.0931 326.351 26.2092Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.847 32.7851C314.283 33.7135 310.148 24.275 306.847 19.7492C306.847 19.7492 306.506 19.2076 306.392 18.55C312.311 20.6002 327.752 31.3152 320.847 32.7851Z",
    fill: "url(#paint10_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.43 18.55C307.264 18.8595 308.099 19.2463 308.896 19.6331C309.693 20.0587 310.489 20.4842 311.286 20.9483C312.842 21.8767 314.359 22.8438 315.839 23.9269C317.318 25.01 318.722 26.1318 320.05 27.4083C320.695 28.0272 321.302 28.7235 321.833 29.4584C322.099 29.8453 322.326 30.2321 322.44 30.6576C322.554 31.0831 322.554 31.586 322.288 31.9341C322.023 32.2822 321.605 32.4756 321.188 32.6304C321.074 32.6691 320.96 32.7077 320.847 32.7077C320.733 32.7464 320.619 32.7464 320.505 32.7464C320.278 32.7851 320.05 32.7851 319.822 32.7851C318.912 32.7851 318.039 32.553 317.204 32.2049C315.573 31.4699 314.207 30.1934 313.031 28.8008C310.641 26.0157 308.934 22.7277 306.809 19.7492C307.872 21.2578 308.782 22.8438 309.768 24.3911C310.755 25.9384 311.779 27.4856 312.955 28.8782C314.131 30.2708 315.497 31.5473 317.167 32.3209C318.001 32.7077 318.912 32.9011 319.822 32.9398C320.05 32.9398 320.278 32.9398 320.505 32.9012C320.619 32.9012 320.733 32.8625 320.847 32.8625C320.96 32.8238 321.074 32.8238 321.188 32.7851C321.605 32.6691 322.061 32.437 322.364 32.0501C322.516 31.8567 322.592 31.6246 322.592 31.3925C322.592 31.1604 322.554 30.9284 322.516 30.6963C322.364 30.2321 322.137 29.8453 321.871 29.4584C321.34 28.6848 320.733 28.0272 320.05 27.3696C318.722 26.0931 317.28 24.9713 315.801 23.9269C314.321 22.8825 312.804 21.8767 311.21 20.987C310.413 20.5228 309.617 20.0973 308.82 19.7105C308.099 19.2463 307.264 18.8595 306.43 18.55Z",
    fill: "#FF805E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M308.167 16.1519C308.774 15.7264 309.154 14.9141 308.358 13.4442C305.743 7.371 297.289 -6.55485 290.266 3.73416C288.633 6.09367 287.835 8.18244 287.607 9.84575C288.559 2.03208 303.73 11.5485 308.167 16.1519Z",
    fill: "url(#paint11_linear_bow_button_330)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.454 3.46369C297.439 -6.28374 305.741 7.40997 308.356 13.4444C308.849 14.3728 308.849 15.0304 308.697 15.4946C305.437 10.1564 296.829 -0.674929 290.454 3.46369Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M287.609 9.84694C285.978 18.8985 301.95 16.6163 306.768 16.6163C306.768 16.6163 307.603 16.5776 308.172 16.1521C303.733 11.549 289.696 -0.442449 287.609 9.84694Z",
    fill: "url(#paint12_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.998 14.9918C304.115 12.2067 301.042 9.61498 297.551 7.64219C295.806 6.67513 293.947 5.82412 291.936 5.70808C290.95 5.6694 289.888 5.94018 289.129 6.63646C288.37 7.33274 287.915 8.2998 287.649 9.26686C287.384 10.2339 287.308 11.317 287.573 12.3228C287.801 13.3285 288.446 14.2182 289.243 14.8371C290.874 16.0749 292.923 16.4618 294.858 16.7325C298.803 17.2354 302.787 16.8099 306.732 16.6165C302.787 16.6938 298.803 17.0807 294.858 16.5778C292.923 16.307 290.912 15.8815 289.319 14.6824C288.56 14.1021 287.953 13.2511 287.725 12.2841C287.498 11.317 287.573 10.3113 287.839 9.34421C288.105 8.37716 288.522 7.44879 289.243 6.79119C289.964 6.13359 290.95 5.86281 291.936 5.90149C293.909 5.97885 295.768 6.82986 297.513 7.75824C299.259 8.72529 300.89 9.88576 302.445 11.0849C304.039 12.3227 305.556 13.5993 306.998 14.9918Z",
    fill: "url(#paint13_linear_bow_button_330)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M307.909 17.5067C308.402 16.9651 308.667 16.1528 307.415 15.0697C303.885 11.4723 290.566 1.33795 289.279 12.2851C288.787 16.5789 289.167 19.364 290.534 20.7179C287.611 15.3798 302.976 16.2303 307.909 17.5067Z",
    fill: "url(#paint14_linear_bow_button_330)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M289.239 12.7473C289.239 12.5926 289.277 12.4379 289.277 12.2445C290.572 1.29759 303.884 11.4328 307.41 15.0304C308.245 15.7654 308.396 16.3456 308.244 16.8485C303.048 13.9084 293.679 9.96246 289.239 12.7473Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.532 20.6776C293.947 24.4685 302.521 19.904 306.998 18.1246C306.998 18.1246 307.529 17.8925 307.908 17.5057C302.976 16.2292 286.511 15.4555 290.532 20.6776Z",
    fill: "url(#paint15_radial)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.908 17.5056C306.239 17.0801 304.532 16.8867 302.824 16.732C301.117 16.5772 299.372 16.4999 297.665 16.5386C295.957 16.5772 294.212 16.6933 292.543 17.1188C292.126 17.2348 291.708 17.3509 291.329 17.5443C290.949 17.7377 290.532 17.9698 290.267 18.318C290.115 18.4727 290.001 18.7048 289.963 18.9369C289.925 19.169 289.925 19.4011 289.963 19.6332C290.077 20.0974 290.305 20.4842 290.57 20.8323C291.063 21.3739 291.746 21.7994 292.429 22.0315C293.15 22.2636 293.871 22.3409 294.592 22.3023C296.071 22.2636 297.513 21.9154 298.917 21.4899C300.32 21.0644 301.686 20.5229 303.052 19.9426C304.418 19.3624 305.746 18.7435 307.074 18.2019C305.708 18.7435 304.38 19.3237 303.014 19.9039C301.648 20.4455 300.282 20.987 298.879 21.4126C297.475 21.8381 296.033 22.1475 294.592 22.1862C293.871 22.1862 293.15 22.1089 292.429 21.8768C291.746 21.6447 291.101 21.2578 290.608 20.7163C290.342 20.3681 290.115 19.9813 290.039 19.5945C289.925 19.169 290.039 18.7435 290.342 18.434C290.608 18.1245 290.987 17.8925 291.367 17.699C291.746 17.5056 292.164 17.3896 292.581 17.2735C294.25 16.848 295.957 16.732 297.665 16.6933C299.372 16.6546 301.117 16.732 302.824 16.848C304.494 16.9254 306.239 17.1188 307.908 17.5056Z",
    fill: "#FE7758"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.419 10.8519C307.151 8.72451 311.133 11.7419 311.133 11.7419C313.181 13.8695 306.085 17.1957 308.131 21.8377C308.131 21.8377 302.858 21.7987 301.418 17.7757C300.965 12.9018 304.419 10.8519 304.419 10.8519Z",
    fill: "url(#paint16_radial)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M311.135 11.7032C311.287 11.858 311.4 12.0901 311.476 12.3222C311.514 12.5542 311.514 12.7863 311.438 13.0184C311.286 13.4826 311.058 13.8694 310.792 14.2562C310.261 15.0298 309.653 15.726 309.084 16.4996C308.552 17.2733 308.059 18.1242 307.831 19.0526C307.717 19.5167 307.679 19.9809 307.716 20.4838C307.754 20.948 307.905 21.4122 308.095 21.8377C307.716 20.9867 307.641 19.9809 307.907 19.0913C308.135 18.2016 308.628 17.3506 309.16 16.6157C309.691 15.8421 310.299 15.1459 310.83 14.3336C311.096 13.9468 311.324 13.5213 311.476 13.0571C311.552 12.825 311.552 12.5929 311.476 12.3608C311.438 12.0901 311.287 11.858 311.135 11.7032Z",
    fill: "#FE7757"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M292.959 4.85693C292.959 4.93425 292.921 5.01156 292.845 5.05023L292.807 5.01158C292.883 4.93426 292.921 4.89559 292.959 4.85693Z",
    fill: "#FE7959"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M293 4.89551L292.848 5.05015C292.924 4.97283 292.962 4.93417 293 4.89551Z",
    fill: "#FE7959"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M292.885 5.05117L292.809 5.01205L292.809 4.97291L292.885 5.05117Z",
    fill: "#FE7959"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M292.96 4.85669C292.922 4.89535 292.884 4.93402 292.808 5.01134L292.96 4.85669C292.998 4.89534 292.998 4.89534 292.96 4.85669Z",
    fill: "#FE7959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_330",
    x1: 159.999,
    y1: 12.9999,
    x2: 160.034,
    y2: 90.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237569,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475138,
    stopColor: "#F98F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552486,
    stopColor: "#FB6950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E90202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_330",
    x1: 66.8602,
    y1: 45.0421,
    x2: 71.7546,
    y2: 74.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_330",
    x1: 66.8602,
    y1: 45.0421,
    x2: 71.7546,
    y2: 74.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_330",
    x1: 66.8602,
    y1: 45.0421,
    x2: 71.7546,
    y2: 74.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_330",
    x1: 66.8602,
    y1: 45.0421,
    x2: 71.7546,
    y2: 74.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bow_button_330",
    x1: 66.8602,
    y1: 45.0421,
    x2: 71.7546,
    y2: 74.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_bow_button_330",
    x1: 307.199,
    y1: 7.88846,
    x2: 206.77,
    y2: 75.4646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_bow_button_330",
    x1: 330.006,
    y1: 17.3946,
    x2: 307.147,
    y2: 14.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.051 21.4128) rotate(-173.439) scale(8.74036 8.90719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_bow_button_330",
    x1: 325.495,
    y1: 27.1237,
    x2: 307.798,
    y2: 15.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.7 27.7458) rotate(-163.208) scale(11.0928 11.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    stopColor: "#A50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#7D0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#650000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#5C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_bow_button_330",
    x1: 290.021,
    y1: 3.7324,
    x2: 309.664,
    y2: 13.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.514 13.4164) rotate(27.3751) scale(8.39125 8.48676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#B30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#610000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_bow_button_330",
    x1: 307.098,
    y1: 15.3732,
    x2: 287.508,
    y2: 9.6867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6713,
    stopColor: "#FF704C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    stopColor: "#FF7C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF805E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_bow_button_330",
    x1: 288.503,
    y1: 14.3363,
    x2: 305.177,
    y2: 12.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012121,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334279,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0777097,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    stopColor: "#FF633D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2651,
    stopColor: "#FF5C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3304,
    stopColor: "#FF4F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#FF4A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#FF805E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9491,
    stopColor: "#B90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.909 27.83) rotate(169.858) scale(16.479 16.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00980392,
    stopColor: "#FF616E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952373,
    stopColor: "#FB4C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    stopColor: "#F11516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    stopColor: "#ED0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#D00200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    stopColor: "#A60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#980000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9247,
    stopColor: "#580000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#4F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314.267 3.43514) rotate(-146.509) scale(18.4579 18.6087)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#F51911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6485,
    stopColor: "#FF453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#FF876E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8314,
    stopColor: "#F63636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BA1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9758,
    stopColor: "#890D01"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton330);
export default __webpack_public_path__ + "static/media/button-330.c22fbaf1.svg";
export { ForwardRef as ReactComponent };